import { action } from 'satcheljs/lib/legacy';
import type { ActionSource } from './types/ActionSource';
import type { default as DatapointOptions, CustomData } from './types/DatapointOptions';

interface DatapointConfigWithFunctions<U extends any[]> {
    name?: string | ((...args: U) => string);
    customData?: CustomData | ((...args: U) => CustomData);
    options?: DatapointOptions | ((...args: U) => DatapointOptions);
    cosmosOnlyData?: string | ((...args: U) => string);
    actionSource?: ActionSource | ((...args: U) => ActionSource);
}

interface RawAction<U extends any[]> {
    (...args: U): Promise<any> | void;
}

interface ActionFactory<U extends any[]> {
    <T extends RawAction<U>>(target: T): T;
    <T extends RawAction<U>>(
        target: any,
        propertyKey: string,
        descriptor: TypedPropertyDescriptor<T>
    ): void;
}

export default function createLegacyActionWithDatapoint<U extends any[] = any[]>(
    actionType: string,
    config?: DatapointConfigWithFunctions<U>
): ActionFactory<U> {
    let datapoint = config || {};
    datapoint.name = datapoint.name || actionType;
    return action(actionType, { datapoint });
}
